import React from "react";
import { Spinner } from "react-rainbow-components";
import {
  Container,
  ContainerContent,
  ContainerCoupon,
  ContainerListUser,
  ContainerPikerCoupon,
  HeaderTitle,
} from "./index.style";
import { RiCoupon3Fill } from "react-icons/ri";
import { MdAdd, MdDelete } from "react-icons/md";
import CouponDetail from "../../components/couponSettingComponent/CouponDetail";
import ModalCreateCoupon from "../../components/couponSettingComponent/ModalCreateCoupon";
import ModalConfirmation from "../../components/common/ModalConfirmation";
import { Picklist, Option } from "react-rainbow-components";
import useCouponSettingPage from "./useCouponSettingPage";
import CardCoupons from "../../components/couponSettingComponent/CardCoupons";

export default function CouponSettingPage() {
  const {
    isOpen,
    setIsOpen,
    fetchData,
    width,
    data,
    setCoupon,
    coupon,
    allUser,
    setIsOpenDelete,
    setDeleteId,
    isLoading,
    isOpenDelete,
    handleDelete,
  } = useCouponSettingPage();

  return !isLoading ? (
    <Container>
      <ModalCreateCoupon
        isOpen={isOpen}
        onRequestClose={() => setIsOpen(false)}
        fetchData={fetchData}
      />
      <ModalConfirmation
        isOpen={isOpenDelete}
        onConfirm={handleDelete}
        onCancel={() => {
          setIsOpenDelete(false);
          setDeleteId(undefined);
        }}
        title={"ยืนยันการลบคูปอง"}
        description={`ยืนยันการลบคูปอง`}
      />
      <HeaderTitle style={{ width: "100%" }}>
        <RiCoupon3Fill size="2rem" />
        <h1>จัดการคูปอง</h1>
      </HeaderTitle>
      <ContainerContent>
        {width > 425 ? (
          <ContainerCoupon>
            <CardCoupons
              productName="สร้างคูปอง"
              productDescription="เพิ่มคูปอง"
              iconButton={<MdAdd size={128} color="#555" />}
              onClick={() => setIsOpen(true)}
            />
            {data.map((item) => (
              <CardCoupons
                key={item.couponId}
                {...item}
                isActive={coupon?.couponId === item.couponId}
                onClickButton={() => setDeleteId(item.couponId)}
                iconButton={<MdDelete size={22} color="#555" />}
                onClick={() => setCoupon(item)}
              />
            ))}
          </ContainerCoupon>
        ) : (
          <ContainerPikerCoupon>
            <Picklist
              placeholder="เลือกคูปอง"
              onChange={(value) =>
                setCoupon(data.find((item) => item.couponId === value.value))
              }
              value={{
                label: coupon?.productName,
                value: coupon?.couponId,
              }}
              hideLabel
            >
              {data.map((item) => (
                <Option
                  name={item.couponId}
                  label={item.productName}
                  value={item.couponId}
                  key={item.couponId}
                />
              ))}
            </Picklist>
          </ContainerPikerCoupon>
        )}
        <ContainerListUser>
          {coupon && <CouponDetail coupon={coupon} allUser={allUser} />}
        </ContainerListUser>
      </ContainerContent>
    </Container>
  ) : (
    <div>
      <Spinner size="large" variant="brand" />
    </div>
  );
}
